<template>

  <section class="city-nav">
    <div class="nav-cat container-fluid">
      <div class="row tabs">
        <router-link :to="'/directorio/'+$route.params.tipo+'/city/juarez'" tag="div" :class="realCity==='juarez'?'active':''" class="col-sm-4">
          <span>JUÁREZ</span>
        </router-link>
        <router-link :to="'/directorio/'+$route.params.tipo+'/city/el-paso'" tag="div" :class="realCity==='el-paso'?'active':''" class="col-sm-4">
          <span>EL PASO</span>
        </router-link>
        <router-link :to="'/directorio/'+$route.params.tipo+'/city/las-cruces'" tag="div" :class="realCity==='las-cruces'?'active':''" class="col-sm-4">
          <span>
            LAS CRUCES
          </span>
        </router-link>
      </div>
    </div>
  </section>

</template>

<script lang="js">
export default {
  name: 'city-nav',
  props: [],
  mounted () {

  },
  data () {
    return {

    }
  },
  methods: {

  },
  computed: {
    realCity () {
      return this.$route.params.ciudad
    }
  }
}
</script>

<style scoped lang="scss">
  .city-nav {
    .nav-cat {
      .tabs {
        cursor: pointer;
        padding-top: 25px;
        padding-bottom: 25px;
        text-align: center;
        .col-sm-4 {
          padding: 15px;
          &:hover {
            text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
          }
          &.active {
            border: 3px solid rgba(250, 156, 23, 0.75);
            border-radius: 45px;
            span{
              color: aliceblue;
            }
          }
        }
      }
    }
  }
</style>
